import { MultipleLocationFoundIcon } from "../../Assets/assets";
import { LocationCard } from "../../Components/Card/Card";

export default function MultipleLocationFound(props) {
  return (
    <div className="inherit-parent-height inherit-parent-width padding-larger">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <MultipleLocationFoundIcon />
        </div>
        <div className="font-size-medium  text-align-center ">
          MULTIPLE PCT FOUND
        </div>
        <div
          style={{
            width: "230px"
          }}
          className="font-size-small text-align-center padding-top-small font-color-tertiaryColor5"
        >
          SELECT YOUR EXACT PCT LOCATION LISTED BELOW
        </div>

        <div
          className="margin-top-larger margin-bottom-larger"
          style={{
            backgroundColor: "#FFFFFF14",
            height: "2px",
            width: "100%"
          }}
        />
        <div className="inherit-parent-width">
          {props.data.map((locationId) => (
            <LocationCard
              data={props.locations?.[locationId]}
              onClick={() => {
                props.setSelectedLocation(locationId);
                props.navigate("/faceIdentification/captureImage");
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
